import classNames from "classnames";
import styles from "./ValidationMessage.module.css";
import StyledButton from "../buttons/StyledButton";
import { useEffect, useState } from "react";

type Props = {
  validationMessages: string[];
  className?: string;
};

export default function ValidationMessage({
  validationMessages,
  className,
}: Props) {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    setHidden(false);
  }, [validationMessages]);

  return validationMessages.length > 0 && !hidden ? (
    <div className={classNames(styles.validationMessages, className)}>
      {validationMessages.join("\n")}

      <StyledButton
        className={styles.closeValidationButton}
        variant="transparent"
        onClick={() => setHidden(true)}
      >
        {"X"}
      </StyledButton>
    </div>
  ) : null;
}
